/* mf-link — la copertina del video diventa iframe solo al clic.
   Nessun embed YouTube prima che qualcuno lo voglia davvero: su un pubblico
   che arriva quasi sempre da mobile, un iframe caricato subito costa ~1 MB. */
(function () {
  document.querySelectorAll('.mfl-frame').forEach(function (frame) {
    var play = frame.querySelector('.mfl-play');
    var poster = frame.querySelector('.mfl-poster');
    if (!play) return;

    play.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src =
        'https://www.youtube-nocookie.com/embed/' +
        frame.dataset.vid +
        '?autoplay=1&rel=0&modestbranding=1&hl=' +
        frame.dataset.lang;
      f.title = play.getAttribute('aria-label');
      f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture; web-share';
      f.allowFullscreen = true;
      frame.appendChild(f);
      play.hidden = true;
      if (poster) poster.hidden = true;
    });
  });
})();
